import { brandName } from './brand';
function loadImg(src) {
  return new Promise((resolve) => { const i = new Image(); i.onload = () => resolve(i); i.onerror = () => resolve(null); i.src = src; });
}

const ACCENTS = ['#8b5cf6', '#06b6d4', '#ec4899', '#22c55e', '#f59e0b'];

export async function makePoster({ title, genre, frame }) {
  const W = 1280, H = 720;
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  const x = c.getContext('2d');
  const seed = [...title].reduce((a, ch) => a + ch.charCodeAt(0), 0);
  const acc = ACCENTS[seed % ACCENTS.length];
  x.fillStyle = '#030712'; x.fillRect(0, 0, W, H);
  const img = frame ? await loadImg(frame) : null;
  if (img) {
    const s = Math.max(W / img.width, H / img.height);
    x.drawImage(img, (W - img.width * s) / 2, (H - img.height * s) / 2, img.width * s, img.height * s);
  } else {
    x.strokeStyle = acc + '33'; x.lineWidth = 1;
    for (let i = 0; i < 40; i++) { x.beginPath(); x.moveTo(W / 2, H * 0.62); x.lineTo((i / 39) * W * 2 - W / 2, H); x.stroke(); }
    for (let i = 0; i < 12; i++) { const y = H * 0.62 + Math.pow(i / 11, 2) * H * 0.38; x.beginPath(); x.moveTo(0, y); x.lineTo(W, y); x.stroke(); }
    for (let i = 0; i < 160; i++) { x.fillStyle = `rgba(200,210,255,${((i * 37) % 10) / 14})`; x.fillRect((i * 97 + seed) % W, (i * 53) % (H * 0.6), 2, 2); }
    const g = x.createRadialGradient(W / 2, H * 0.62, 10, W / 2, H * 0.62, 420); g.addColorStop(0, acc + 'aa'); g.addColorStop(1, 'transparent');
    x.fillStyle = g; x.fillRect(0, 0, W, H);
  }
  const shade = x.createLinearGradient(0, 0, 0, H); shade.addColorStop(0, 'rgba(3,7,18,.15)'); shade.addColorStop(0.55, 'rgba(3,7,18,.25)'); shade.addColorStop(1, 'rgba(3,7,18,.95)');
  x.fillStyle = shade; x.fillRect(0, 0, W, H);
  for (let y = 0; y < H; y += 4) { x.fillStyle = 'rgba(0,0,0,.12)'; x.fillRect(0, y, W, 1); }
  const t = title.toUpperCase();
  let fs = 120; x.font = `800 ${fs}px "JetBrains Mono", monospace`;
  while (x.measureText(t).width > W - 160 && fs > 40) { fs -= 4; x.font = `800 ${fs}px "JetBrains Mono", monospace`; }
  x.textAlign = 'left'; x.textBaseline = 'alphabetic';
  x.shadowColor = acc; x.shadowBlur = 40; x.fillStyle = '#f8fafc'; x.fillText(t, 80, H - 120);
  x.shadowBlur = 0; x.strokeStyle = acc; x.lineWidth = 2; x.strokeText(t, 80, H - 120);
  x.fillStyle = acc; x.fillRect(80, H - 96, 120, 6);
  x.font = '600 26px "JetBrains Mono", monospace'; x.fillStyle = '#67e8f9'; x.fillText((genre || 'ARCADE').toUpperCase(), 220, H - 84);
  x.font = '700 20px "JetBrains Mono", monospace';
  const badge = brandName().toUpperCase();
  const bw = x.measureText(badge).width + 36;
  x.fillStyle = 'rgba(8,13,26,.75)'; x.fillRect(W - 50 - bw, 40, bw, 54); x.strokeStyle = '#8b5cf6'; x.strokeRect(W - 50 - bw, 40, bw, 54);
  x.fillStyle = '#c4b5fd'; x.fillText(badge, W - 32 - bw, 74);
  return c.toDataURL('image/jpeg', 0.85);
}

export async function makeIcon(cover, title, size) {
  const c = document.createElement('canvas'); c.width = c.height = size;
  const x = c.getContext('2d');
  x.fillStyle = '#030712'; x.fillRect(0, 0, size, size);
  const img = cover ? await loadImg(cover) : null;
  if (img) { const s = size / img.height; x.globalAlpha = 0.55; x.drawImage(img, (size - img.width * s) / 2, 0, img.width * s, size); x.globalAlpha = 1; }
  x.font = `800 ${size * 0.5}px "JetBrains Mono", monospace`; x.textAlign = 'center'; x.textBaseline = 'middle';
  x.shadowColor = '#8b5cf6'; x.shadowBlur = size / 10; x.fillStyle = '#f8fafc'; x.fillText((title || 'T')[0].toUpperCase(), size / 2, size / 2);
  return c.toDataURL('image/png');
}
